module.exports = __webpack_public_path__ + "static/media/spacebg.5dc2c39c.jpg";